"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageAttemptFailingEventData = void 0;
class MessageAttemptFailingEventData {
    constructor() {
    }
    static getAttributeTypeMap() {
        return MessageAttemptFailingEventData.attributeTypeMap;
    }
}
exports.MessageAttemptFailingEventData = MessageAttemptFailingEventData;
MessageAttemptFailingEventData.discriminator = undefined;
MessageAttemptFailingEventData.attributeTypeMap = [
    {
        "name": "appId",
        "baseName": "appId",
        "type": "string",
        "format": ""
    },
    {
        "name": "appUid",
        "baseName": "appUid",
        "type": "string",
        "format": ""
    },
    {
        "name": "endpointId",
        "baseName": "endpointId",
        "type": "string",
        "format": ""
    },
    {
        "name": "lastAttempt",
        "baseName": "lastAttempt",
        "type": "MessageAttemptFailedData",
        "format": ""
    },
    {
        "name": "msgEventId",
        "baseName": "msgEventId",
        "type": "string",
        "format": ""
    },
    {
        "name": "msgId",
        "baseName": "msgId",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=MessageAttemptFailingEventData.js.map